import { useLayoutEffect } from "react";

export function useAppAuthMetadata(): void {
  useLayoutEffect(() => {
    const restore = [
      ["robots", "noindex,nofollow"],
      ["referrer", "no-referrer"],
    ].map(([name, content]) => {
      const existing = document.head.querySelector<HTMLMetaElement>(
        `meta[name="${name}"]`,
      );
      const previous = existing?.getAttribute("content") ?? null;
      const element = existing ?? document.createElement("meta");
      element.name = name;
      element.content = content;
      if (!existing) document.head.append(element);
      return (): void => {
        if (!existing) element.remove();
        else if (previous === null) element.removeAttribute("content");
        else element.content = previous;
      };
    });
    return () => {
      for (const undo of restore) undo();
    };
  }, []);
}
